import { createApp } from 'vue';
import { IonicVue } from '@ionic/vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import { seedFromHost } from './services/host-seed';
import { ssoBoot } from './services/sso-boot';

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

/* Theme variables */
import './assets/styles/variables.css';

/* Motyw jasny/ciemny (wspólna tożsamość Firmatic, jak w FFE):
   ?theme=dark|light w URL nadpisuje i zapamiętuje wybór; czytane RAZ przy starcie. */
const themeParams = new URLSearchParams(window.location.search);
const themeFromUrl = themeParams.get('theme');
const theme = themeFromUrl || localStorage.getItem('fm-theme');
if (theme === 'dark') document.documentElement.classList.add('dark');
if (themeFromUrl) localStorage.setItem('fm-theme', themeFromUrl);

/* Siatka bezpieczeństwa po wdrożeniu nowej wersji.
   Doładowywane moduły (ekrany, wtyczki) mają w nazwie hash builda. Jeśli aplikacja
   działa od dłuższego czasu, a jej modułów już nie ma na serwerze, import kończy się
   błędem i funkcja po prostu przestaje działać — bez śladu dla użytkownika. Wtedy
   przeładowujemy stronę, żeby pobrać aktualną wersję. Znacznik w sessionStorage
   chroni przed pętlą, gdy przyczyna jest inna (np. brak sieci). */
window.addEventListener('vite:preloadError', () => {
  const KEY = 'kiosk-reload-po-aktualizacji';
  if (sessionStorage.getItem(KEY)) return;
  sessionStorage.setItem(KEY, String(Date.now()));
  window.location.reload();
});

const app = createApp(App);
const pinia = createPinia();

app.use(IonicVue);
app.use(pinia);
app.use(router);

router.isReady().then(async () => {
  // Najpierw seed per karta (host przez postMessage / sessionStorage po F5), dopiero
  // potem walidacja tokenu — inaczej whoami poleciałoby ze ścieżką z cudzej karty.
  // Mount na końcu: po 401 ssoBoot przestawia chronioną trasę na /login.
  const seed = await seedFromHost();
  await ssoBoot(seed, pinia, router);
  app.mount('#app');
});









